import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class PutAwayApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PUT_AWAY);
  }

  completePutaway(putawayId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${putawayId}/complete/`,
      {},
    );
  }

  getPutawayGRNLines(putawayId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${putawayId}/grn-lines/`,
    );
  }
}

export default new PutAwayApi();
